import type { DeepPartial } from '@luna/utils-ts';

import type { Misc } from '../../types/Misc';

export const miscATFeatureConfig: DeepPartial<Misc> = {
    addTokenToDownloadPayload: true,
    groupingTitles: true,
    securityEntityAcceptVersionAll:
        'application/vnd.at.sitsolutions.services.sec.account.representation.securities.account.list.v3+json',
    securityEntityAcceptVersionSingle:
        'application/vnd.at.sitsolutions.services.sec.account.representation.securities.account.v3+json',
};
